export default __webpack_public_path__ + "static/media/information--highway-preferential-lane--g2.00aa828a.png";